export const mediaPipeInteractiveSegmenterModelUrl =
  "https://storage.googleapis.com/mediapipe-models/interactive_segmenter/magic_touch/float32/1/magic_touch.tflite";

export const mediaPipeVisionWasmBaseUrl =
  "https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.35/wasm";

export const mediaPipeVisionWasmUrl = `${mediaPipeVisionWasmBaseUrl}/vision_wasm_module_internal.wasm`;
